import React, { useState, useEffect, FC } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { ethers } from 'ethers';
import SocialVaultContract from '../artifacts/contracts/SocialVault.sol/SocialVault.json';
import BuyStake from '../components/BuyStake';

const Buy:FC = () => {
  const { address } = useParams();
  const [stakes, setStakes] = useState<any>([]);
  const [vaultData, setVaultData] = useState<any>('');
  const [loading, setLoading] = useState<boolean>(true);

  async function getAvailableStakes() {
    try {
      setLoading(true);
      const dappSocialVault: any = new ethers.Contract(
        (address as string),
        SocialVaultContract.abi,
        ethers.getDefaultProvider(process.env.REACT_APP_DEFAULT_NETWORK)
      );

      const data = await dappSocialVault.getVaultDetails();
      const stakes = await dappSocialVault.getUserBalancesForSale();
      setVaultData(data);
      setStakes(stakes);
      setLoading(false);
    } catch (e) {
      console.log((e as Error).message);
    }
    setLoading(false);
  }

  function renderStakes(stakes: any) {
    if (stakes.length === 0 || stakes[0] === undefined) {
      return (<h1>Nothing to buy</h1>);
    }

    const stakeComponents = stakes.map((stake: any) => {
      if (stake.isSelling) {
        return <BuyStake
          key={stake.userAddress}
          address={stake.userAddress}
          name={vaultData[1]}
          stakedAmount={stake.balance.toString()}
          sellingFor={stake.sellingFor.toString()}
          url={vaultData[6]}
        />;
      }
    });

    return stakeComponents;
  }

  useEffect(() => {
    getAvailableStakes();
  }, []);

  return(
    <Grid columns='equal'>
      <Grid.Column width={1}>
        <div className="outer">
          <div className="inner rotate">BUY&nbsp;STAKE</div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="App-header">
            { loading ? 'Loading...' : renderStakes(stakes) }
        </div>
      </Grid.Column>
      <Grid.Column width={2} />
    </Grid>
  )
}

export { Buy };
